import XzTagGroup from './src/tagGroup';

/* istanbul ignore next */
XzTagGroup.install = function (Vue) {
  Vue.component(XzTagGroup.name, XzTagGroup);
};

export default XzTagGroup;
